export default __webpack_public_path__ + "static/media/EM1030.34I-29213_-16957_0.e233b693.jpg";